import { Resend } from "resend"

// Initialize Resend with API key
// In production, this should be an environment variable
const RESEND_API_KEY = "re_123456789" // Replace with your actual API key

export const resend = new Resend(RESEND_API_KEY)

// Helper function to send welcome email
export const sendWelcomeEmail = async (email: string, name: string) => {
  try {
    const data = await resend.emails.send({
      from: "Passes <welcome@passes.com>",
      to: email,
      subject: "Welcome to Passes - Your Digital Loyalty Platform",
      html: `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
          <h1 style="color: #4f46e5;">Welcome to Passes!</h1>
          <p>Hello ${name},</p>
          <p>Thank you for signing up for Passes, the digital loyalty platform that helps you bring customers back automatically.</p>
          <p>Here's what you can do next:</p>
          <ul>
            <li>Create your first digital loyalty pass</li>
            <li>Customize your branding</li>
            <li>Send your first campaign</li>
          </ul>
          <p>If you need any help getting started, just reply to this email.</p>
          <p>Best regards,<br>The Passes Team</p>
        </div>
      `,
    })

    return { success: true, data }
  } catch (error) {
    console.error("Error sending welcome email:", error)
    return { success: false, error }
  }
}

// Helper function to send campaign notification
export const sendCampaignNotification = async (email: string, campaignName: string) => {
  try {
    const data = await resend.emails.send({
      from: "Passes <campaigns@passes.com>",
      to: email,
      subject: `New Campaign: ${campaignName}`,
      html: `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
          <h1 style="color: #4f46e5;">New Campaign Created</h1>
          <p>Your campaign "${campaignName}" has been created successfully.</p>
          <p>You can now track its performance in your dashboard.</p>
          <p>Best regards,<br>The Passes Team</p>
        </div>
      `,
    })

    return { success: true, data }
  } catch (error) {
    console.error("Error sending campaign notification:", error)
    return { success: false, error }
  }
}

// Helper function to send password reset email
export const sendPasswordResetEmail = async (email: string, resetToken: string) => {
  try {
    const resetUrl = `https://passes.com/reset-password?token=${resetToken}`

    const data = await resend.emails.send({
      from: "Passes <security@passes.com>",
      to: email,
      subject: "Reset Your Passes Password",
      html: `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
          <h1 style="color: #4f46e5;">Reset Your Password</h1>
          <p>You requested a password reset for your Passes account.</p>
          <p>Click the button below to reset your password:</p>
          <a href="${resetUrl}" style="display: inline-block; background-color: #4f46e5; color: white; padding: 10px 20px; text-decoration: none; border-radius: 5px; margin: 20px 0;">Reset Password</a>
          <p>If you didn't request this, you can safely ignore this email.</p>
          <p>Best regards,<br>The Passes Team</p>
        </div>
      `,
    })

    return { success: true, data }
  } catch (error) {
    console.error("Error sending password reset email:", error)
    return { success: false, error }
  }
}
